import {EventEmitter, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {DataSource} from "./content.store"
import {HttpClient} from "@angular/common/http";
import {
  ModuleCertificateAttachmentData,
  ModuleCertificateDestinationData,
  moduleInfo,
  modulesType,
  NotificationSettings,
  setAction,
  settingsType
} from "./content.types";
import {ToastService} from 'ng-uikit-pro-standard';
import {infoStepType} from "../communications/communications-types";
import {SystemGlobalsService} from "../system-globals.service";
import {Router} from "@angular/router"
import {Preset, PresetSaveData, PresetType} from './modules/schedule/schedule-types';
import {LearningCenterService} from "../learning-center.service";
import {tap} from "rxjs/operators";
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Injectable({
  providedIn: 'root'
})

export class ContentService {

  currentSelectedTab = "drafts";

  public isSearchResultsActive: boolean = false;
  public currentUserRole: number;

  public fetchModulesUrl: string = "/courses/getCourses";
  public statusModuleUrl: string = "/modules/set_status.json";
  public fetchModuleSettingsUrl: string = "/modules/getModuleData.json";
  public saveAsUrl = "/modules/save_copy.json";
  public createModuleUrl = "/modules/add.json";
  public editUrl = "/modules/edit";
  public prepareModuleUrl = "/modules/checkPublishedModuleStatus";
  public editModuleUrl = "/modules/edit_module/";
  public gerVersionsUrl = "/modules/getModuleVersions";
  public setFavoriteUrl = "/modules/favorite/";
  public setGroupsUrl = "/modules/saveGroup.json";
  public deleteGroupUlr = "/modules/deleteGroup.json";
  public setModuleGroupUrl = "/modules/setModuleGroup.json";
  public searchUrl = "/courses/searchApi";
  readonly getModulePresetDataUrl = '/modules/getModulePresetData.json';
  readonly getCategoriesUrl = "/learningCenter/getCategories";
  readonly deleteCategoryUrl = "/module_categories/delete/";
  readonly createCategoryUrl = "/module_categories/create.json"
  public saveModulePresetURL = "/content/savePreset"
  public getNotificationSettingsUrl = "/notificationsetting/getSettings";
  public saveNotificationSettingsUrl = "/notificationsetting/saveSettings"

  readonly fetchCertificateDataUrl = '/modules/getCertificateDestinations';
  readonly saveModuleCertificateDestinationsUrl = '/modules/saveCertificateDestinations';
  readonly saveModuleCertificateAttachmentsUrl = '/modules/attachments/';

  public clearSearchEmitter = new EventEmitter();
  public modulePrepareStatus = new EventEmitter();
  public editModuleId = 0;
  private _dataStore = new DataSource();

  public categoriesStore = new BehaviorSubject(this._dataStore.store.categories);
  public printData = new BehaviorSubject("");
  public modulesStore = new BehaviorSubject(this._dataStore.store.modules);
  public selectedModuleStore = new BehaviorSubject(this._dataStore.store.selectedModule);
  public filterResultsModulesStore = new BehaviorSubject(this._dataStore.store.filteredResults);
  public searchResultsModulesStore = new BehaviorSubject(this._dataStore.store.searchTermResults);
  public selectedModulesFromStore = new BehaviorSubject(this._dataStore.store.selectedModules);
  public createModuleInfoStepStore = new BehaviorSubject(this._dataStore.store.currentInfoText);
  public searchTermFromStore = new BehaviorSubject(this._dataStore.store.searchTerm);
  public searchResultsFromStore = new BehaviorSubject(this._dataStore.store.searchResults);
  public updatedGroups = new BehaviorSubject(this._dataStore.store.groups);
  public presetFromStore = new BehaviorSubject(this._dataStore.store.modulePresets);
  public updateModuleSettingsStore = new BehaviorSubject(this._dataStore.store.settings);

  selectFavorite: boolean = false;

  constructor(
    private http: HttpClient,
    private _systemGlobalsService: SystemGlobalsService,
    private toast: ToastService,
    private LearningCenterService: LearningCenterService,
    private router?: Router,
  ) {
    this._dataStore.globals = _systemGlobalsService;
    this.fetchAllModules();
    this.getLoggedInRole();
    this.fetchInstructors();
    this.LearningCenterService.getStudentOptions();
  }

  fetchAllModules(callback?: Function) {


    this.http.get<Array<modulesType>>(this.fetchModulesUrl).subscribe((m) => {

      this._dataStore.setAllModulesStore(m);

      // console.log(this._dataStore.store.modules)
      // this._dataStore.setFilters();

      // this._dataStore.store.categories = m["categories"];
      this.modulesStore.next(this._dataStore.store.modules);
      this.fetchAllCategories();
      if (callback) {
        callback(m);
      }
    })
  };

  getModulesFromStore() {
    return this._dataStore.store.modules;
  }

  fetchNotificationSettings(id, type) {
    return this.http.post<NotificationSettings>(this.getNotificationSettingsUrl, {objectID: id, type, from:'1'})
  }

  saveNotificationSettings(payload, callback) {
    this.http.post(this.saveNotificationSettingsUrl, payload).subscribe((e) => {
      callback(e);
    })
  }

  getModuleFromStore(id: number) {
    return this._dataStore.store.modules.get(Number(id));
  }

  convertBool(event: any, model) {
    // if (model == "stickyHeader") {
    // }
    this._dataStore.store.settings[model] = event ? 1 : 0;
  }

  getModuleSettings() {
    if (!this._dataStore.store.settings) {
      this._dataStore.store.settings = new settingsType();
    }

    this._dataStore.store.settings.minimum_required_course_time_seconds = (
      (this._dataStore.store.settings.minimum_required_course_time_hours * 3600) +
      (this._dataStore.store.settings.minimum_required_course_time_minutes * 60)
    ).toString();

    this._dataStore.store.settings.maximum_course_time_seconds = (
      (this._dataStore.store.settings.MaximumModuleTimeDays * 86400) +
      (this._dataStore.store.settings.MaximumModuleTimeHours * 3600) +
      (this._dataStore.store.settings.MaximumModuleTimeHours * 60)
    ).toString();

    this._dataStore.store.settings.course_time_cert = this._dataStore.store.settings ? 1 : 0;

        for(const [key, value] of Object.entries(this._dataStore.store.settings)){
          if (typeof value == 'boolean'){
            this.convertBool(this._dataStore.store.settings[key], key);
          }
        }

    // this.convertBool(this._dataStore.store.settings.course_time_cert, 'course_time_cert');
    // this.convertBool(this._dataStore.store.settings.exclude_exam_time, 'exclude_exam_time');
    // this.convertBool(this._dataStore.store.settings.practical, 'practical');
    // this.convertBool(this._dataStore.store.settings.stickyHeader, "stickyHeader");
    // this.convertBool(this._dataStore.store.settings.default_header_status, "default_header_status");
    // this.convertBool(this._dataStore.store.settings.default_footer_status, "default_footer_status");
    // this.convertBool(this._dataStore.store.settings.course_navigation, "course_navigation");
    // this.convertBool(this._dataStore.store.settings.navigation_lock, "navigation_lock");
    // this.convertBool(this._dataStore.store.settings.assign_course_mark, "assign_course_mark");
    // this.convertBool(this._dataStore.store.settings.assign_course_mark, "assign_course_mark");
    // this.convertBool(this._dataStore.store.settings.auto_assign_retain_month, "auto_assign_retain_month");
    // this.convertBool(this._dataStore.store.settings.assignment_notify_student, "assignment_notify_student");
    // this.convertBool(this._dataStore.store.settings.assignment_notify_manager, "assignment_notify_manager");
    // this.convertBool(this._dataStore.store.settings.assignment_notify_manager, "assignment_notify_registrar");
    // this.convertBool(this._dataStore.store.settings.maximum_course_time_notify_manager, "maximum_course_time_notify_manager");
    // this.convertBool(this._dataStore.store.settings.expiration_notify_status, "expiration_notify_status");
    // this.convertBool(this._dataStore.store.settings.expires, "expires");
    // this.convertBool(this._dataStore.store.settings.maximum_course_time, "maximum_course_time");
    // this.convertBool(this._dataStore.store.settings.maximum_course_time_notify_instructor, "maximum_course_time_notify_instructor");
    // this.convertBool(this._dataStore.store.settings.notifyArDueDate, "notifyArDueDate");
    // this.convertBool(this._dataStore.store.settings.recurrent, "recurrent");
    // this.convertBool(this._dataStore.store.settings.recurrent, "recurrent");




    // this.convertBool(this._dataStore.store.settings.minimum_required_course_time_open_nav, "minimum_required_course_time_open_nav");


    return this._dataStore.store.settings;
  }

  createModuleSettings() {
    this._dataStore.store.settings = new settingsType();
    return this._dataStore.store.settings;
  }

  setPrintData(data){
    this.printData.next(data)
  }

  getGroups() {
    return this._dataStore.store.groups;
  }

  getSelectedModulesCount(){
    return this._dataStore.store.selectedModules.size;
  }

  getModuleVersions(id, callback) {
    let formData = new FormData();
    formData.append('moduleId', id);

    this.http.post(this.gerVersionsUrl, formData).subscribe((v) => {
      this._dataStore.store.versions = v;
      callback(v);
    })
  }

  updateGroups(groups, callback?: Function) {
    if (groups.delete["id"]) {

      let index = this._dataStore.store.groups.findIndex((c) => c.id == groups.delete["id"]);
      this._dataStore.store.groups.splice(index, 1);

      this.http.post(this.deleteGroupUlr, groups.delete).subscribe((d) => {
        if (callback) callback(d);
        return;
      })
    }

    this.http.post(this.setGroupsUrl, groups.collection).subscribe((r) => {
      this._dataStore.remapGroups(r);
      this.updatedGroups.next(this._dataStore.store.groups);
      if (callback) callback(r);
    })
  }

  setGroupModule(groupIds, moduleId) {
  //on update
    let formData = new FormData();

    formData.append('groupIds', JSON.stringify(groupIds));
    formData.append('moduleId', moduleId);

    this.http.post(this.setModuleGroupUrl, formData).subscribe((f) => {
      this.toast.success('Updated', 'Success', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});
    })
  }

  fetchAllCategories(callback?) {

    this.http.get(this.getCategoriesUrl).subscribe((e) => {
      this._dataStore.store.categories = [];
      let ids = [];

      for (let c in e) {
        this._dataStore.store.categories.push({id: +c, name: e[c], canDelete: true})
        ids.push(+c);
      }

      this._dataStore.store.modules.forEach((cat) => {
        if (ids.includes(cat.categories["categoryID"])) {
          this._dataStore.store.categories.find((c) => c.id == cat.categories["categoryID"]).canDelete = false;
        }
      });
      this.categoriesStore.next(this._dataStore.store.categories);
      if (callback) {
        callback(this._dataStore.store.categories);
      }

    })

  }

  createCategory(name) {
    this.http.post(this.createCategoryUrl, {name}).subscribe((r) => {
      this._dataStore.store.categories.push({id: r["data"].id, name});
    })
  }

  deleteCategory(id) {

    let exists = false

    this._dataStore.store.modules.forEach((c) => {
      if (c.categories['categoryID'] == id) {
        exists = true;
      }
    })

    if (exists) {
      this.toast.error("can't delete, category in use", 'Error', {
        positionClass: 'md-toast-bottom-left',
        toastClass: 'opaque'
      });
    } else {
      this.http.get(this.deleteCategoryUrl + id + ".json").subscribe((r) => {
        let ind = this._dataStore.store.categories.findIndex((f) => f.id == id);
        this._dataStore.store.categories.splice(ind, 1);
      })
    }
  }

  fetchModuleSettings(module: modulesType, callback?: Function) {
    if (module) {

      this.http.post<Array<modulesType>>(this.fetchModuleSettingsUrl, {id: module.courseID}).subscribe((m) => {

        this._dataStore.store.settings = new settingsType(m["module"]?.Course, module).settings;
        this._dataStore.store.settings.instructor = m["module"]?.Instructors;
        this._dataStore.store.settings.courseCategory = m["module"]?.CourseCategory.categoryID ?? 0;
        this._dataStore.store.settings.cert_attachments =  m["module"]['cert_attachments']

        if (callback) {
          callback(this._dataStore.store.settings);
        }
      })
    } else {
      this._dataStore.store.settings = new settingsType();
      if (callback) {
        callback(this._dataStore.store.settings);
      }
    }

    return this._dataStore.store.settings;
  }

  getModulePresetData() {
    // return this.http.get<Preset[]>(this.getModulePresetDataUrl).subscribe((d) => {
    //   this._dataStore.store.modulePresets = d;
    //   // this.presetFromStore.next(d);
    // });

    return this.http.get<Preset[]>(this.getModulePresetDataUrl).pipe(tap(d => this._dataStore.store.modulePresets = d))

  }

  updateModuleSettings(data) {

    this._dataStore.store.settings = data;
    this.updateModuleSettingsStore.next(this._dataStore.store.settings);
  }

  saveModulePresets(name, payload) {

    let data = new Preset(PresetType.ModuleAutoRecurrent).getSaveData(payload);

    let newObj: PresetSaveData = {
      name,
      type: PresetType.ModuleAutoRecurrent,
      data: data,
    }

    this.http.post<PresetSaveData>(this.saveModulePresetURL, newObj).subscribe((c) => {
      this.toast.success('Preset Saved', 'Success', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});
    })
  }

  fetchModulePresets(): Preset[] {
    return this._dataStore.store.modulePresets;
  }

  setStatusHttp(id, action, callback: Function) {
    this.http.post<setAction>(this.statusModuleUrl, {module_id: id, status_action: action}).subscribe(
      success => {
        if (this.getSelectedModulesCount() == 0){
        this.toast.success('Changes Saved', 'Success', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});
        }
        callback()
      }, error => {
        this.toast.error('Something went wrong', 'Error', {
          positionClass: 'md-toast-bottom-left',
          toastClass: 'opaque'
        });
      })
  }

  saveSettings(callback?: Function) {

    let settings = this.getModuleSettings();

//    // settings.course_time_cert = settings.course_time_cert ? "1" : "0";

    this.http.post(this.editUrl, {Course: settings, CourseCategory: {categoryID: settings.courseCategory}}).subscribe(
      success => {

        let module = this._dataStore.store.modules.get(+settings.courseID);
        module.course_name = settings.course_name;
        module.tags = settings.tags;

        this.toast.success('Changes Saved', 'Success', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});
        if (callback) {
          callback();
        }

      }, error => {

        this.toast.error('Something went wrong', 'Error', {
          positionClass: 'md-toast-bottom-left',
          toastClass: 'opaque'
        });
      })
  }

  createSettings(callback: Function) {

    let settings = this.getModuleSettings();

    settings.course_time_cert = settings.course_time_cert ? "1" : "0";
    settings.settings.author_userID = this._dataStore.globals.constants.userID;

    let course = {Course: settings.settings, CourseCategory: {"categoryID": settings.settings.courseCategory}};

    this.http.post(this.createModuleUrl, course).subscribe(
      success => {
        this.toast.success('Changes Saved', 'Success', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});
       callback(success);
      }, error => {
        this.toast.error('Something went wrong', 'Error', {
          positionClass:  'md-toast-bottom-left',
          toastClass: 'opaque'
        });
      })
  }

  publishModule(id, callback: Function) {
    this.selectFavorite  = true;
    if (id) {
      this.setStatusHttp(id, "publish", () => {
        this._dataStore.store.modules.get(id).status = 1;
        this.modulesStore.next(this._dataStore.store.modules);
        callback()
      })
    }
  }

  unPublishModule(id, callback: Function) {
    this.selectFavorite  = true;
    if (id) {
      this.setStatusHttp(id, "unpublish", () => {
        this._dataStore.store.modules.get(id).status = 0;
        this.modulesStore.next(this._dataStore.store.modules);
        callback()
      })
    }
  }

  archiveModule(id, callback: Function) {
    this.selectFavorite  = true;
    if (id) {
      this.setStatusHttp(id, "archive", () => {
        this._dataStore.store.modules.get(id).status = 2;
        this.modulesStore.next(this._dataStore.store.modules);
        callback()
      })
    }
  }

  saveAsModule(module: modulesType, title, callback: Function) {
    this.selectFavorite  = true;
    let alreadyExists = false;
    this._dataStore.store.modules.forEach((c) => {
      if (c.course_name == title) {
        alreadyExists = true;
      }

    });

    if (!alreadyExists) {

      let newModule: modulesType = module;
      // newModule.course_name = title;
      newModule.status = 0;

      this.http.post(this.saveAsUrl, newModule).subscribe(success => {

        let newModule = new modulesType(module);
        let newId = success['message']['courseID']

        newModule.courseID = parseInt(newId);
        newModule.course_name = title;

        let newCollection = Array.from(this._dataStore.store.modules);
        newCollection.unshift([newModule.courseID, newModule]);

        this._dataStore.store.modules = new Map<number, modulesType>(newCollection);

        this.toast.success('Changes Saved', 'Success', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});
        this.modulesStore.next(this._dataStore.store.modules);

       callback(newModule);

      }, error => {
        this.toast.error('Something went wrong', 'Error', {
          positionClass: 'md-toast-bottom-left',
          toastClass: 'opaque'
        });
      })
    } else {
      callback(null);
    }
    // module_id =
    //   title_new = ""
    // isExpress: false
  }

  public viewModule(id, page = 0) {
    window.location.href = `/student/preview_learn/${id}?page=${page}`
  }

  editModule(id, callback) {
    this.editModuleId = id;
    this.http.post(this.editModuleUrl + id, {}).subscribe((success) => {
      callback();
    }, (error) => {
      this.toast.error('Something went wrong', 'Error', {
        positionClass: 'md-toast-bottom-left',
        toastClass: 'opaque'
      });
      callback('error');
    })
  }

  prepareModule(modules: any[]) {

    let formData = new FormData();
    formData.append('modules[]', modules[0]);

    setTimeout(() => {

      this.http.post<setAction>(this.prepareModuleUrl, formData).subscribe((r) => {
        if (r[0].status < 9) {
          this.prepareModule(modules);
        }
        this.modulePrepareStatus.emit(r[0].status)
      })
    }, 2000)
  }

  deleteModule(id, callback: Function) {
    if (id) {
      this.setStatusHttp(id, "delete", () => {
        this._dataStore.store.modules.delete(id);
        this.modulesStore.next(this._dataStore.store.modules);
        callback()
      })
    }
  }

  unarchiveModule(id, callback: Function) {
    if (id) {
      this.setStatusHttp(id, "unarchive", () => {
        this._dataStore.store.modules.get(id).status = 0;
        this.modulesStore.next(this._dataStore.store.modules);
        callback()
      })
    }
  }

  fetchAddendum(id, callback: Function) {
    this.http.post("/courses/viewAddendums", {module_id: id}).subscribe((r) => {
      this._dataStore.store.moduleInfo.addendum = r;
      if (callback) {
        callback(r);
      }
    })
  }

  fetchModuleInfo(module: modulesType, callback?: Function) {

    this.http.post<Array<modulesType>>("/courses/getCourseInfo", {module_id:module.courseID}).subscribe((info) => {
      this._dataStore.store.moduleInfo = new moduleInfo(info);
      if (callback) {
        callback(info);
      }
    })
  }

  addModuleToStore(moduleId, module){
    this._dataStore.store.modules.set(moduleId, module);

    this.modulesStore.next(this._dataStore.store.modules);

  }

  public clearModuleSettings() {
    this._dataStore.store.settings = new settingsType();
  }

  getInstructors() {
    return this._dataStore.store.instructors;
  }

  fetchInstructors() {
    this.LearningCenterService.fetchInstructorsList().subscribe((i) => {
      this._dataStore.store.instructors = i
    })
  }

  updateKeywords(keywords) {

    let keywordList = [];
    if (keywords.length > 0) {
      keywordList = keywords.reduce((accum, curr) => {
        accum.push(curr.name);
        return accum;
      }, []);
    } else {
      keywordList.push(keywords)
    }

    this._dataStore.store.settings.tags = keywordList.toString();
    this.saveSettings(() => {
    })

  }

  getCategories() {
    return this._dataStore.store.categories;
  }

  setSelectedModule(module) {
    this.clearSelectedModules();
    this._dataStore.store.selectedModule = module;
    this.selectedModuleStore.next(module)
  }

  updateFavoriteModule(module) {
    this.selectFavorite = true;
    this.http.post(this.setFavoriteUrl + module.courseID + ".json", {}).subscribe(() => {
      this._dataStore.store.modules.get(module.courseID).isFavorite = !module.isFavorite;
      this.modulesStore.next(this._dataStore.store.modules);
    })
  }

  filterBasedOnQueryStrings(label) {
    this.currentSelectedTab = label;
    this._dataStore.fetchFilterModules(label, () => {
      let sortedModules = this._dataStore.store.filteredResults.sort((a, b) => b.date_created_timestamp - a.date_created_timestamp);
      this.filterResultsModulesStore.next(sortedModules);

    })
  }

  fetchSearchResults(request) {

    let searchQuery = {
      title: request.keyword,
      module_status: this.currentSelectedTab == "drafts" ? "draft" : this.currentSelectedTab,
      searchFilter: request.misc,
      courseID: request.module == 0 ? '' : request.module.toString()
    }

    let string = new URLSearchParams(searchQuery).toString()

    this.http.get(this.searchUrl + "?" + string).subscribe((s) => {
      this._dataStore.setSearchResultsStore(s, (results) => {
        this.searchResultsFromStore.next(results)
      });
    })
  }

  fetchCertificateData(moduleId: number) {
   return this.http.post(this.fetchCertificateDataUrl,{moduleId: moduleId});
  }

  saveModuleCertificateAttachments(paths: string[], courseId) {

    let attachments = paths.map(path => {
      return {path: path}
    });

    this.http.post(this.saveModuleCertificateAttachmentsUrl + courseId, {
      CertificateAttachments: attachments
    }).subscribe((r)=>console.log(r))
  }

  saveModuleCertificateDestinations(destinations: ModuleCertificateDestinationData) {

    this.http.post(this.saveModuleCertificateDestinationsUrl, {
      destinations
    }).subscribe((d) => {
      console.log("done")
    });
  }

  setSearchTerm(term) {
    this._dataStore.store.searchTerm = term;
    this.searchTermFromStore.next(term);
  }

  public getSearchTerm() {
    return this._dataStore.store.searchTerm;
  }

  setSearchResults(term) {

    // 'clear-search-field' term is to reset search data
    if (term == "clear-search-field") {
      this.modulesStore.next(this._dataStore.store.modules);
      this.isSearchResultsActive = false;
    } else {
      this.isSearchResultsActive = true;
      let termString = term.toString();
      if (termString.length > 2) {
        let modulesArray = Array.from(this._dataStore.store.modules.values());
        this._dataStore.store.searchTermResults = modulesArray.filter((e) => e?.course_name?.toString().toLocaleLowerCase().includes(term.toLocaleLowerCase()))
        this.searchResultsModulesStore.next(this._dataStore.store.searchTermResults)
      }
    }
  }

  searchFilterResults(filter) {
    let collection = new Set();

    this._dataStore.store.modules.forEach((m) => {

      if (Array.from(filter.categories).includes(m.categories["categoryID"])) {
        collection.add(m);
      }

      let groupArr = Array.from(filter.groups)
      if (m.groupIds.length > 0) {
        groupArr.forEach((g) => {
          if (m.groupIds.includes(+g)) {
            collection.add(m);
          }
        })
      }
      if (filter.keywords && filter.keywords.length > 0) {
        filter.keywords.forEach((k) => {
          if (m.tags && m.tags.split(",").map(s=>s.trim().toLowerCase()).includes(k.name.trim().toLowerCase())) {
            collection.add(m);
          }
        })
      }

    });

    this.isSearchResultsActive = true;
    this._dataStore.store.searchTermResults = Array.from(collection);
    this.searchResultsModulesStore.next(this._dataStore.store.searchTermResults)

  }

  clearSearchResults() {
    this._dataStore.store.searchResults = [];
  }

  matchGroups(groupIds: any[]) {
    return this._dataStore.store.groups.filter((g) => groupIds.includes(g.id));
  }

  setInfoText(value: infoStepType) {
    this._dataStore.store.currentInfoText = {title: value.title, text: value.text};
    this.createModuleInfoStepStore.next(this._dataStore.store.currentInfoText)
  }

  getLoggedInRole() {
    this.currentUserRole = this._dataStore.globals.constants.userRole
  }

  clearSearchField() {
    this.clearSearchEmitter.emit(true);
  }

  genericToast(message) {
    this.toast.success(message, 'Success', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});
  }


  public setSelectedModules(module){

    if (this._dataStore.store.selectedModules.has(module.courseID)){
      this._dataStore.store.selectedModules.delete(module.courseID);
    } else {
     this._dataStore.store.selectedModules.set(module.courseID,module);

    }
    this._dataStore.store.modules.get(module.courseID)['checked'] = !this._dataStore.store.modules.get(module.courseID)['checked']
    this.selectedModulesFromStore.next(this._dataStore.store.selectedModules)

  }

  public getSelectedModules(){
    return this._dataStore.store.selectedModules;
  }

  public clearSelectedModules(){
    this._dataStore.unsetSelectedModules();
    this.selectedModulesFromStore.next(this._dataStore.store.selectedModules)
  }

  public setRecurrent(module: modulesType) {
    this._dataStore.store.modules.get(module.courseID).recurrent_status = 1;
    this.modulesStore.next(this._dataStore.store.modules);
  }

  public contextItemAction(event: any) {

    switch (event) {
      case "Blank" :
        this.router.navigate(['content/create']);
        break;
      case "From PowerPoint" :
        this.router.navigate(['content/modules/create/powerpoint']);
        break;
      case "From Backup" :
        this.router.navigate(['content/modules/create/backup']);
        break;
    }
  }

  public validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

}
